let component = {
  template: '<ui-view/>'
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/vehicle.component.js